export default __webpack_public_path__ + "static/media/Lauren_DeVera_AHV_In_Moms_We_Trust.9a6a5dbc.jpg";